import { useEffect, useState } from "react";
import { toast } from "sonner";
import { ClipboardCheck, Mail } from "lucide-react";
import { api, errText } from "../lib/api";
import { Card, Meter } from "./bits";

export const Runbook = ({ isSuper }) => {
  const [d, setD] = useState(null);
  const [busy, setBusy] = useState(false);
  const load = () => api.get("/admin/ops/runbook").then((r) => setD(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);
  const tick = async (key, done) => { try { await api.put(`/admin/ops/runbook/${key}`, { done }); load(); } catch (e) { toast.error(errText(e)); } };
  const notify = async () => { if (!window.confirm("Email every beta tester who has not yet accepted the current Terms?")) return; setBusy(true); try { const { data } = await api.post("/admin/ops/notify-consent"); toast.success(`Consent notice sent to ${data.sent} tester(s)`); } catch (e) { toast.error(errText(e)); } finally { setBusy(false); } };
  if (!d) return null;
  return (
    <Card className="mt-4" title="Launch-day runbook" sub={`${d.done} of ${d.total} steps ticked · ticks are audited`} testId="runbook-card">
      <Meter value={(d.done / d.total) * 100} />
      <div className="mt-3">{d.items.map((it) => (
        <label key={it.key} className="flex gap-2" style={{ padding: "6px 0", cursor: isSuper ? "pointer" : "default", alignItems: "flex-start" }} data-testid={`runbook-item-${it.key}`}>
          <input type="checkbox" className="chk" checked={!!it.done} disabled={!isSuper} onChange={(e) => tick(it.key, e.target.checked)} data-testid={`runbook-tick-${it.key}`} />
          <span style={{ textDecoration: it.done ? "line-through" : "none", color: it.done ? "var(--ink-3)" : "inherit" }}>{it.text}{it.done && it.by && <span className="sub"> · {it.by} {new Date(it.at).toLocaleDateString()}</span>}</span>
        </label>))}</div>
      {isSuper && <div className="flex gap-2 mt-3"><button className="btn sm ghost" onClick={notify} disabled={busy} data-testid="notify-consent-btn"><Mail size={13} /> {busy ? "Sending…" : "Email beta testers about updated Terms"}</button><span className="sub"><ClipboardCheck size={12} /> One-page checklist for launch morning.</span></div>}
    </Card>
  );
};
